import { useEffect, useRef } from 'react';
import theme from '../adminTheme';

/**
 * Modal reutilizable: cierra con Escape, click fuera y botón.
 * Incluye focus trap básico (focus en el primer elemento enfocable).
 */
const AdminModal = ({ open, onClose, title, children, width }) => {
  const overlayRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  useEffect(() => {
    if (open && contentRef.current) {
      const focusable = contentRef.current.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusable) focusable.focus();
    }
  }, [open]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) onClose();
  };

  if (!open) return null;

  return (
    <div
      ref={overlayRef}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? 'admin-modal-title' : undefined}
      style={theme.modalOverlay}
      onClick={handleOverlayClick}
    >
      <div
        ref={contentRef}
        style={{
          ...theme.modal,
          maxWidth: width || theme.modal.maxWidth
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <h2 id="admin-modal-title" style={theme.modalTitle}>
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
};

export default AdminModal;
